import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  ButtonBase,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import TelegramIcon from '@mui/icons-material/Telegram';
import authService from '../../services/authService';

export default function AppUserMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    setOpen(false);
  };

  const handleGoRoot = () => {
    navigate('/');
  };

  const companyMatch = location.pathname.match(/^\/companies\/([^/]+)/);
  const companyHomePath = companyMatch ? `/companies/${companyMatch[1]}/home` : null;
  const showCompanyHomeButton = companyHomePath !== null && location.pathname !== companyHomePath;

  const handleGoCompanyHome = () => {
    if (companyHomePath) {
      navigate(companyHomePath);
    }
  };

  const handleOpenTelegram = () => {
    setOpen(false);
    navigate('/telegram');
  };

  const handleLogout = async () => {
    setOpen(false);
    await authService.logout();
  };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        color="transparent"
        sx={(theme) => ({
          backgroundColor: alpha(theme.palette.background.default, 0.88),
          backdropFilter: 'blur(14px)',
          borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        })}
      >
        <Toolbar
          sx={{
            minHeight: 64,
            px: {
              xs: 2,
              sm: 3,
            },
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <ButtonBase
            onClick={handleGoRoot}
            sx={(theme) => ({
              borderRadius: 1.5,
              px: 1,
              py: 0.5,
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
              },
            })}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
              }}
            >
              NSTA CRM
            </Typography>
          </ButtonBase>

          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            {showCompanyHomeButton && (
              <IconButton
                aria-label="На головну компанії"
                onClick={handleGoCompanyHome}
                sx={(theme) => ({
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.16)}`,
                  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                  },
                })}
              >
                <HomeIcon />
              </IconButton>
            )}

            <IconButton
              aria-label="Відкрити меню"
              onClick={() => setOpen(true)}
              sx={(theme) => ({
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: `1px solid ${alpha(theme.palette.primary.main, 0.16)}`,
                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                },
              })}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
      >
        <Box
          sx={{
            width: 280,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
          role="presentation"
        >
          <Box
            sx={{
              px: 3,
              py: 2.5,
            }}
          >
            <Typography variant="h6" component="h2">
              Меню
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Швидкі дії та налаштування акаунту
            </Typography>
          </Box>

          <Divider />

          <List sx={{ px: 1.5, py: 1.5 }}>
            <ListItemButton
              onClick={handleOpenTelegram}
              sx={{
                borderRadius: 2,
              }}
            >
              <ListItemIcon>
                <TelegramIcon />
              </ListItemIcon>
              <ListItemText primary="Telegram" />
            </ListItemButton>
            <ListItemButton
              onClick={handleLogout}
              sx={{
                borderRadius: 2,
              }}
            >
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Вийти" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
    </>
  );
}